import { Button, Modal } from "@findemdev/maui";
import { useCallback } from "react";
import { ICompanyList } from "../../../types/common";


interface IDeleteCompanyListModalProps {
  data: ICompanyList | undefined;
  isLoading: boolean;
  onOk: (companyList: ICompanyList) => Promise<void>;
  onCancel: () => void;
};

const DeleteCompanyListModal = ({
  data,
  isLoading,
  onOk,
  onCancel,
}: IDeleteCompanyListModalProps) => {

  const onCancelWrapper = useCallback(() => {
    if (data) {
      onOk(data);
    }
  }, [onOk, data]);

  return <Modal
    open={!!data}
    onCancel={onCancel}
    footer={[
        <Button
          key="cancel"
          onClick={onCancel}
        >
          Cancel
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onCancelWrapper}
          loading={isLoading}
        >
          Confirm
        </Button>
      ]}
    title="Are you sure you want to delete?"
  >
    Deleting this Company List is permanent. There is no way to undo this action.
  </Modal>
};

export default DeleteCompanyListModal;